//@flow
import React from "react";
import { WhenFieldChanges } from "../../shared/CommonComponents";

const DesiredDateFieldNames = {
  desiredProviderChangeFieldNames: {
    desiredProviderChangeDate: "desiredProviderChangeDate",
    desiredProviderChangeDateDay: "desiredProviderChangeDateDay",
    desiredProviderChangeDateMonth: "desiredProviderChangeDateMonth",
    desiredProviderChangeDateYear: "desiredProviderChangeDateYear",
  },
  canceledMyselfDateFieldNames: {
    canceledMyselfDate: "canceledMyselfDate",
    canceledMyselfDateDay: "canceledMyselfDateDay",
    canceledMyselfDateMonth: "canceledMyselfDateMonth",
    canceledMyselfDateYear: "canceledMyselfDateYear",
  },
};

const DesiredDateChanges = () => {
  return (
    <>
      {Object.keys(DesiredDateFieldNames.desiredProviderChangeFieldNames).map((property, index) => (
        <WhenFieldChanges
          key={"desiredProviderChange_changes_" + index}
          field="cancelOldContract"
          becomes={"CANCELLED_ALREADY"}
          set={DesiredDateFieldNames.desiredProviderChangeFieldNames[property]}
          to={""}
        />
      ))}
      {Object.keys(DesiredDateFieldNames.canceledMyselfDateFieldNames).map((property, index) => (
        <WhenFieldChanges
          key={"canceledMyselfDate_changes_" + index}
          field="cancelOldContract"
          becomes={"CUSTOM_SWITCHING_DATE"}
          set={DesiredDateFieldNames.canceledMyselfDateFieldNames[property]}
          to={""}
        />
      ))}
    </>
  );
};

export default DesiredDateChanges;
